<template>
  <div>
    <list
      ref="list"
      unit="收入单"
      row-key="DocId"
      light-row
      :page="page"
      @row-select="x=>$emit('change', x)"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      show-summary  
      :summary-method="getSummaries"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单位名称">
           <!-- <el-input
                v-model="params.TradeUnitName"
                @focus="addUnit"
                placeholder="请选择"
                size="mini"
                readonly
              ></el-input> -->
            <customer  @restaurants='setSupplier' :state='params.TradeUnitName' :typeList="[1, 3]" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="票据类型">
          <!-- <invoice-select v-model="params.InvoiceTypeId" /> -->
           <invoice-select
                  v-model="params.InvoiceTypeId"
                  :clearable="false"
                />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="业务类型">
          <business-select
            v-model="params.BusinessTypeId"
            :params="{Kind:'应收',SourceType:'收入单'}"
            @change="onChange"
          />
        </el-form-item>
        <el-form-item label="收入名称">
          <el-input size="mini" v-model="params.IncomeName" placeholder="请填写收入名称"></el-input>
        </el-form-item>
        <el-form-item label="经办人">
          <!-- <el-input size="mini" v-model="params.ClerkName" placeholder="请填写经办人"></el-input> -->
             <select-input
            placeholder="请选择经办人"
            :label="params.ClerkName"
            v-model="params.ClerkId"
            @click="openEmp"
          />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="BusinessType" label="业务类型" />
        <el-table-column prop="InvoiceTypeName" label="票据类型" />
        <el-table-column prop="ClerkName" label="经办人" />
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="TaxAmount" label="税额" />
        <el-table-column prop="IncTaxAmount" label="含税金额" />
        <el-table-column prop="ReceiptAmount" label="收款金额" />
        <!-- <el-table-column prop="RemainAmount" label="未收金额" /> -->
        <el-table-column prop="Status" label="单据状态" align="center" width="90">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
            <el-tag type="primary" v-else-if="row.Status==1">未生效</el-tag>
            <el-tag type="success" v-else>已生效</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
      <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" title='单位列表' :typeList="[1,2]" />
      <emp-dialog ref="empDialog" selectable @select="setEmp" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
// import businessSelect from "@/components/basedoc/business/select";
// import invoiceSelect from "@/components/basedoc/invoice/select";
import businessSelect from "@/components/basedoc/business/select";
import invoiceSelect from "@/components/basedoc/invoice/select";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import empDialog from "@/components/sales/business/empDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: {
    list,
    businessSelect,
    invoiceSelect,
    unitDialog,
    empDialog,
    customer
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {},
  data() {
    return {
      api: require("@/api/fund/contactcash/income").default,
      cList: [],
      params: {
        ClerkName: "",
        ClerkId:"",
        IncomeName: "",
        TradeUnitName: "",
        TradeUnitId:"",
        DocNo: "",
        BusinessTypeId: null,
        BusinessType: "",
        InvoiceTypeId: null,
        Status: null,
        DocDateStart:this.$commonJs.getDayOffset(-30),
        DocDateEnd:this.$commonJs.getDayOffset(0)
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 6||index === 7|| index === 8||index === 9 ) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    setEmp(data) {
      this.params.ClerkId = data.EmpId;
      this.params.ClerkName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.params.TradeUnitId = e.Id
      this.params.TradeUnitName = e.Name
    },
    onChange(e,data) {
      // 
      this.params.BusinessType = data.BusinessType;
    },
    delRange(Id) {
      this.api.delete({ Id }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>